import { inject, Injectable } from '@angular/core';
import {AbstractControl, ValidatorFn} from "@angular/forms";
import {RelayPoint} from "../../Models/relayPoint";
import relayPoints from './relayPoint.json';
import {Wilaya} from "../../Models/wilaya";
import {Town} from "../../Models/town";
import {LanguageService} from "../../Services/language.service";
import {DropdownOption} from "admin-common";

const WILAYAS = [
  {name: 'Adrar', value: "ADRAR", idWilaya: "1", nameAr: "أدرار"},
  {name: 'Chlef', value: "CHLEF", idWilaya: "2", nameAr: "الشلف"},
  {name: 'Laghouat', value: "LAGHOUAT", idWilaya: "3", nameAr: "الأغواط"},
  {name: 'Oum El Bouaghi', value: "OUM_EL_BOUAGHI", idWilaya: "4", nameAr: "أم البواقي"},
  {name: 'Batna', value: "BATNA", idWilaya: "5", nameAr: "باتنة"},
  {name: 'Béjaïa', value: "BEJAIA", idWilaya: "6", nameAr: "بجاية"},
  {name: 'Biskra', value: "BISKRA", idWilaya: "7", nameAr: "بسكرة"},
  {name: 'Béchar', value: "BECHAR", idWilaya: "8", nameAr: "بشار"},
  {name: 'Blida', value: "BLIDA", idWilaya: "9", nameAr: "البليدة"},
  {name: 'Bouira', value: "BOUIRA", idWilaya: "10", nameAr: "البويرة"},
  {name: 'Tamanrasset', value: "TAMANRASSET", idWilaya: "11", nameAr: "تمنراست"},
  {name: 'Tébessa', value: "TEBESSA", idWilaya: "12", nameAr: "تبسة"},
  {name: 'Tlemcen', value: "TLEMCEN", idWilaya: "13", nameAr: "تلمسان"},
  {name: 'Tiaret', value: "TIARET", idWilaya: "14", nameAr: "تيارت"},
  {name: 'Tizi Ouzou', value: "TIZI_OUZOU", idWilaya: "15", nameAr: "تيزي وزو"},
  {name: 'Alger', value: "ALGER", idWilaya: "16", nameAr: "الجزائر"},
  {name: 'Djelfa', value: "DJELFA", idWilaya: "17", nameAr: "الجلفة"},
  {name: 'Jijel', value: "JIJEL", idWilaya: "18", nameAr: "جيجل"},
  {name: 'Sétif', value: "SETIF", idWilaya: "19", nameAr: "سطيف"},
  {name: 'Saïda', value: "SAIDA", idWilaya: "20", nameAr: "سعيدة"},
  {name: 'Skikda', value: "SKIKDA", idWilaya: "21", nameAr: "سكيكدة"},
  {name: 'Sidi Bel Abbès', value: "SIDI_BEL_ABBES", idWilaya: "22", nameAr: "سيدي بلعباس"},
  {name: 'Annaba', value: "ANNABA", idWilaya: "23", nameAr: "عنابة"},
  {name: 'Guelma', value: "GUELMA", idWilaya: "24", nameAr: "قالمة"},
  {name: 'Constantine', value: "CONSTANTINE", idWilaya: "25", nameAr: "قسنطينة"},
  {name: 'Médéa', value: "MEDEA", idWilaya: "26", nameAr: "المدية"},
  {name: 'Mostaganem', value: "MOSTAGANEM", idWilaya: "27", nameAr: "مستغانم"},
  {name: 'M\'Sila', value: "MSILA", idWilaya: "28", nameAr: "المسيلة"},
  {name: 'Mascara', value: "MASCARA", idWilaya: "29", nameAr: "معسكر"},
  {name: 'Ouargla', value: "OUARGLA", idWilaya: "30", nameAr: "ورقلة"},
  {name: 'Oran', value: "ORAN", idWilaya: "31", nameAr: "وهران"},
  {name: 'El Bayadh', value: "EL_BAYADH", idWilaya: "32", nameAr: "البيض"},
  // {name: 'Illizi', value: "ILLIZI", idWilaya: "33", nameAr: "إليزي"},
  {name: 'Bordj Bou Arreridj', value: "BORDJ_BOU_ARRERIDJ", idWilaya: "34", nameAr: "برج بوعريريج"},
  {name: 'Boumerdès', value: "BOUMERDES", idWilaya: "35", nameAr: "بومرداس"},
  {name: 'El Tarf', value: "EL_TARF", idWilaya: "36", nameAr: "الطارف"},
  {name: 'Tindouf', value: "TINDOUF", idWilaya: "37", nameAr: "تندوف"},
  {name: 'Tissemsilt', value: "TISSEMSILT", idWilaya: "38", nameAr: "تيسمسيلت"},
  {name: 'El Oued', value: "EL_OUED", idWilaya: "39", nameAr: "الوادي"},
  {name: 'Khenchela', value: "KHENCHELA", idWilaya: "40", nameAr: "خنشلة"},
  {name: 'Souk Ahras', value: "SOUK_AHRAS", idWilaya: "41", nameAr: "سوق أهراس"},
  {name: 'Tipaza', value: "TIPAZA", idWilaya: "42", nameAr: "تيبازة"},
  {name: 'Mila', value: "MILA", idWilaya: "43", nameAr: "ميلة"},
  {name: 'Aïn Defla', value: "AIN_DEFLA", idWilaya: "44", nameAr: "عين الدفلى"},
  {name: 'Naâma', value: "NAAMA", idWilaya: "45", nameAr: "النعامة"},
  {name: 'Aïn Témouchent', value: "AIN_TEMOUCHENT", idWilaya: "46", nameAr: "عين تموشنت"},
  {name: 'Ghardaïa', value: "GHARDAIA", idWilaya: "47", nameAr: "غرداية"},
  {name: 'Relizane', value: "RELIZANE", idWilaya: "48", nameAr: "غليزان"}
]

@Injectable({
  providedIn: 'root'
})
export class AdressGlobalService {

  provinceList: Wilaya[] = WILAYAS;
  relayPointsList: RelayPoint[] = relayPoints;

  private languageService = inject(LanguageService);

  constructor() { }

  /**
   * Dropdown option of a relay point in the current language: the value is a translated copy (the selected point
   * details card shows its province and address) keeping the original in `source`, see toOriginalRelayPoint
   */
  getRelayPointOption(point: RelayPoint): DropdownOption {
    const arabic = this.languageService.isArabic;
    const province = ((arabic && point.provinceAr) || point.province).trim();
    const address = (arabic && point.addressAr?.length ? point.addressAr : point.address).map((line) => line.trim());
    return {
      label: province + " (" + address[0] + ")",
      value: { ...point, province, address, source: point },
    };
  }

  /** The original (French) relay point of a dropdown option value: the one sent with the order */
  toOriginalRelayPoint(point: RelayPoint): RelayPoint;
  toOriginalRelayPoint(point: RelayPoint | null | undefined): RelayPoint | null | undefined;
  toOriginalRelayPoint(point: RelayPoint | null | undefined): RelayPoint | null | undefined {
    return point?.source ?? point;
  }

  getWilayas(): Wilaya[] {
    return WILAYAS;
  }

  /** Display name of a wilaya enum value (SETIF -> Sétif), in French: the one sent with the order address */
  getWilayaName(wilaya: string): string {
    return WILAYAS.find((w) => w.value === wilaya)?.name ?? wilaya;
  }

  /** Name of a wilaya (enum value or item) in the current language (SETIF -> سطيف in Arabic) */
  getWilayaLabel(wilaya: string | Wilaya): string {
    const item = typeof wilaya === 'string' ? WILAYAS.find((w) => w.value === wilaya) : wilaya;
    if (!item) return wilaya as string;
    return (this.languageService.isArabic && item.nameAr) || item.name;
  }

  editRelayPoints(selectedRelay: string) : string{

    let wilaya : string;

    switch (selectedRelay) {
      case 'ALGER2':
        wilaya = 'ALGER';
        break;
      case 'ORAN2':
        wilaya = 'ORAN';
        break;
      case 'OUARGLA2':
        wilaya = 'OUARGLA'
        break;
      case 'OUARGLA3':
        wilaya = 'OUARGLA'
        break;

      default:
        wilaya = selectedRelay
        break;
    }

    return wilaya;
  }

  public filterRelayPoint(name: string): RelayPoint[] {
    const filterValue = name.toLowerCase();
    return this.relayPointsList.filter(option => option.value.toLowerCase().indexOf(filterValue) === 0);
  }

  public filterWilaya(name: string): Wilaya[] {
    const filterValue = name.toLowerCase();
    return this.provinceList.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  public townFilter(name: string,towns:Town[]): Town[] {
    const filterValue = name.toLowerCase();
    return towns.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  forbiddenRelayPointValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // below findIndex will check if control.value is equal to one of our options or not
      const index = relayPoints.findIndex(province => {
        return (new RegExp('\^' + province.value + '\$')).test(control.value);
      });
      return index < 0 ? {'forbiddenRelayPoint': {value: control.value}} : null;
    };
  }

 forbiddenProvinceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // below findIndex will check if control.value is equal to one of our options or not
      const index = this.provinceList.findIndex(province => {
        return (new RegExp('\^' + province.value + '\$')).test(control.value);
      });
      return index < 0 ? {'forbiddenProvinces': {value: control.value}} : null;
    };
  }
}
